import React from 'react';
import { Provider } from 'react-redux';
import store from './redux/store';
import { BrowserRouter as Router } from 'react-router-dom';
import Views from './views';
import { Route, Switch } from 'react-router-dom';
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import { THEME_CONFIG } from './configs/AppConfig';
import { KeycloakProvider } from '@react-keycloak/web'
import keycloak from 'auth/keycloak'
import ErrorBoundary from 'components/layout-components/Errorboundry/ErrorBoundary';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "./antd-overrides.css";
import { PermissionProvider } from "react-permission-role";
import { ENV_CONFIG } from 'utils/envConfig';


const themes = {
  dark: `${window._env_?.PUBLIC_URL || process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${window._env_?.PUBLIC_URL || process.env.PUBLIC_URL}/css/light-theme.css`,
};

function App() {
    const token = localStorage.getItem('token');
    const refreshToken = localStorage.getItem('refreshToken');
    const idToken = localStorage.getItem('idToken');
    const keycloakTokens = {token, refreshToken, idToken}
    
  const setTokens = (token, idToken, refreshToken) => {
      localStorage.setItem('token', JSON.stringify(token));
      localStorage.setItem('refreshToken', JSON.stringify(refreshToken));
      localStorage.setItem('idToken', JSON.stringify(idToken));
  }
 
  return (
    <div className="App">
      <PermissionProvider>
      <KeycloakProvider
        keycloak={keycloak} 
        onTokens={(tokens) => 
          setTokens(tokens.token ?? '', tokens.idToken ?? '', tokens.refreshToken ?? '')} 
        initOptions={{ onLoad: 'login-required', token, refreshToken }}
      >
        <Provider store={store}>
          <ThemeSwitcherProvider themeMap={themes} defaultTheme={THEME_CONFIG.currentTheme} insertionPoint="styles-insertion-point">
            <Router>
              <ErrorBoundary>
                <ToastContainer autoClose={2000} />
                <Switch>
                  <Route path="/" component={Views}/>
                </Switch>
              </ErrorBoundary>
            </Router>
          </ThemeSwitcherProvider>
        </Provider>
      </KeycloakProvider>
      </PermissionProvider>
    </div>
  );
}

export default App;
